import { ILocalization, ILocalizationToken } from '../../../application/language/ILocalization';
import { extensionContainer } from '../../../common/container/ContainerContext';
import { inject } from '../../../common/container/inject';
import { IRestService, RestServiceToken } from '../../common/rest/IRestService';
import { WrongCredentialError } from '../activeUser/error/WrongCredentialError';
import { IAccountService } from './IAccountService';

export type UpdatePasswordDTO = {
  newPassword: string;
  confirmPassword: string;
  oldPassword?: string;
}

export class RestAccountService implements IAccountService {
  constructor(protected restService: IRestService = inject<IRestService>(RestServiceToken)) {}

  private extractErrorMessage(error: any): string {
    const collect = (value: any, acc: string[]) => {
      if (!value) return;

      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed) {
          acc.push(trimmed);
        }
        return;
      }

      if (Array.isArray(value)) {
        value.forEach((item) => collect(item, acc));
        return;
      }

      if (typeof value === 'object') {
        if (typeof value.message === 'string') {
          collect(value.message, acc);
        }
        if (value.data) {
          collect(value.data, acc);
        }
        if (value.children) {
          collect(value.children, acc);
        }
        if (value.constraints && typeof value.constraints === 'object') {
          Object.values(value.constraints).forEach((item) => collect(item, acc));
        }
      }
    };

    const messages: string[] = [];
    collect(error, messages);
    return messages[0] || 'Password change error';
  }

  async getUserSourceType(): Promise<any> {
    try {
      const res = await this.restService.get<any, any>(this.makeUrl('/account/user-source-type'));
      return res
    } catch (error) {
      this.errorHandler(error);
    }
  }

  async updatePassword({ newPassword, confirmPassword, oldPassword}: UpdatePasswordDTO): Promise<any> {
    try {
      await this.restService.post<any, any>(this.makeUrl('/account/change-password'), { newPassword, confirmPassword, oldPassword });
    } catch (error) {
      this.errorHandler(error);
    }

    return true;
  }

  async forceChangePassword({ newPassword, confirmPassword}: UpdatePasswordDTO): Promise<any> {
    try {
      await this.restService.put<any, any>(this.makeUrl('/account/password'), { newPassword, confirmPassword });
    } catch (error) {
      this.errorHandler(error);
    }

    return true;
  }

  

  makeUrl(uri: string) {
    const domain = this.restService.getConfig().url.api.public;
    return `${domain}${uri}`;
  }

  errorHandler = (error: any) => {
    if (String(error?.webCode ?? '') === '404') {
      const i18n: ILocalization = extensionContainer.getByToken(ILocalizationToken);
      throw new WrongCredentialError([
        {
          message: i18n.translate('login.incorrectValid'),
          target: 'login',
        },
      ]);
    } else {
      const normalizedError = new Error(this.extractErrorMessage(error));
      (normalizedError as any).originalError = error;
      throw normalizedError;
    }
  };
}
